import { CAM_IMG_PATH } from "../../../../utils/constants";
import "./style.css";

const PlaceholderImage = (props) => {
  const { className, onChooseFile } = props;

  return (
    <div className={`file-uploader ${className}`}>
      <div onClick={onChooseFile} className="btn choose-file-btn">
        <img src={CAM_IMG_PATH} alt={CAM_IMG_PATH} />
      </div>
    </div>
  );
};

export default PlaceholderImage;
